import React, { useState, useContext, useEffect } from "react";

import { useForm } from "react-hook-form";
//Estilos , Icons y Alerta
import {
  Grid,
  Box,
  Fab,
  TextField,
  Tooltip,
  InputLabel,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  styled,
} from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import BrandsContext from "../../../Context/Brands/BrandsContext";

//
const useStyles = styled({
  logoimagen: {
    height: "200px",
    objectFit: "cover",
  },
  input: {
    display: "none",
  },
  card: {
    marginTop: 7,
    marginLeft: 7,
    marginRight: 7,
  },
  titleCard: {
    color: "white",
    fontSize: "30px",
    // fontFamily: "roboto",
    fontWeight: "bolder",
    paddingLeft: 10,
  },
  fab: {
    position: "relative",
    marginTop: 10,
  },
});

export default function Add(props) {
  const classes = useStyles();
  const { modal, handleClose } = props;

  const [image, setImage] = useState({
    urlPhoto:
      "https://cloud.wapizima.com/test/products/6425fdfb86a3a9414410e226/Image_not_available.png",
    image: "",
  });

  const handleChangeImage = (e) => {
    setImage({
      ...image,
      urlPhoto: URL.createObjectURL(e.target.files[0]),
      image: e.target.files[0],
    });
  };

  const formAddBrandsContext = useContext(BrandsContext);
  const { success, AddBrand } = formAddBrandsContext;
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  useEffect(() => {
    if (success) {
      setValue("name", "", { shouldDirty: true });
      setValue("image", "", { shouldDirty: true });
      setImage({
        urlPhoto:
          "https://cloud.wapizima.com/test/products/6425fdfb86a3a9414410e226/Image_not_available.png",
        image: "",
      });
    }
  }, [success]);

  const onSubmit = (data, e) => {
    data.image = image.image;

    AddBrand(data);
    handleClose();
  };

  return (
    <Dialog open={modal} onClose={handleClose}>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#FFBEA0",
            textAling: "center",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            borderRadius: "0 0 24px 0",
          }}
        >
          <div className={classes.titleCard}>Agrega Marca</div>
          <div className={classes.fab}>
            <Tooltip title='cerrar' arrow>
              <Fab
                size='small'
                onClick={handleClose}
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#FF0000",
                  "&:hover": {
                    color: "#FFFFFF",
                    backgroundColor: "#FF0000",
                  },
                }}
              >
                <CancelPresentationIcon />
              </Fab>
            </Tooltip>
          </div>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Aquí, podras registrar marcas para nuevos productos
        </DialogContentText>
        <form
          onSubmit={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.code === "Enter" || e.code === "NumpadEnter")
              e.preventDefault();
          }}
          autoComplete='off'
        >
          <Box sx={{ width: "100%", display: "flex", paddingTop: 4, p: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <img
                      src={image.urlPhoto}
                      className={classes.logoimagen}
                      alt='agrega marca'
                    />
                  </div>
                </Box>

                <input
                  className={classes.input}
                  id='icon-button-file'
                  type='file'
                  name='image'
                  accept='image/png, image/jpg, image/jpeg, image/webp'
                  onChange={handleChangeImage}
                />
                <InputLabel sx={{ textAlign: "center" }}>
                  Selecciona Imagen o logo de la Marca :
                  <label htmlFor='icon-button-file'>
                    <IconButton
                      color='primary'
                      aria-label='upload picture'
                      component='span'
                    >
                      <Tooltip
                        title='seleccionar imagen'
                        aria-label='seleccionar imagen'
                      >
                        <PhotoCamera />
                      </Tooltip>
                    </IconButton>
                  </label>
                </InputLabel>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  fullWidth
                  id='name'
                  placeholder='Ejemplo: Princess'
                  name='name'
                  label='Nombre de la Marca Asociada'
                  variant='outlined'
                  type='text'
                  error={errors.name ? true : false}
                  helperText={errors?.name?.message}
                  {...register("name", {
                    required: {
                      value: true,
                      message: "Este campo es requerido",
                    },
                    minLength: {
                      value: 4,
                      message: "Minimo 4 caracteres",
                    },
                    maxLength: {
                      value: 255,
                      message: "Maximo 255 caracteres",
                    },
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                    textAling: "center",
                  }}
                >
                  <div className={classes.fab}>
                    <Fab
                      type='submit'
                      variant='extended'
                      sx={{
                        backgroundColor: "#FFBEA0",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#FFBEA0",
                          color: "white",
                        },
                      }}
                    >
                      <SaveOutlinedIcon sx={{ mr: 1 }} />
                      Guardar
                    </Fab>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
}
